$(function () {
    $(document).on('click', '.live-timer__switch-button', function () {
        $(this).closest('.live-timer').toggleClass('m-show-current');
    });
});